/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { AllMagazineDocument, MagazineDocument, PaginaDocument } from '@gql/graphql'
import { MagazineDetailTemplate } from '@components/templates'

const MagazineDetail = ({ pagina, magazine }) => (
  <MagazineDetailTemplate pagina={pagina} magazine={magazine} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { allMagazine },
  //   } = await client.query({
  //     query: AllMagazineDocument,
  //   })

  //   allMagazine?.forEach((x) => paths.push({ params: { slug: x.slug }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/magazine/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { magazine },
    } = await client.query({
      query: MagazineDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!magazine) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        contentTypeId: magazine.model,
        objectId: magazine.pk,
        chiave: 'magazine-detail',
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { magazine, pagina },
      revalidate: 60 * 20,
    }
  },
  '/magazine/[slug]'
)

export default MagazineDetail
